import config from 'config';
import { Route } from 'config/routes';
import { put, select, take } from 'redux-saga/effects';
import { RootAction } from 'store/state';
import { listingSearchDataSelector } from 'store/state/domainData/selectors';
import { SET_DOMAIN_DATA } from 'store/state/domainData/types';
import { navigateTo } from 'store/state/router/actions';
import { marketplaceSelector } from 'store/state/selectors/router';
import { ListingStatusType, MarketplaceType } from 'utils/entities';
import { formatRoomsRange } from 'utils/filtersFormatter';
import { LoadType } from './apiService/types';
import { resetDomainData } from 'store/state/domainData/actions';

const DEFAULT_CITY_TERM = config.cityTerm;

export const fetchListingSearchDataPattern = (action: RootAction) => (
  action.type === SET_DOMAIN_DATA && action.loadType === LoadType.ListingSearchData
  && Boolean(action.payload.data && action.payload.data.listingSearchData && 'status' in action.payload.data.listingSearchData && action.payload.data.listingSearchData.status !== ListingStatusType.Displayed)
);

export function* checkNoListingRedirectWatcher() {
  let listingSearchData = yield select(listingSearchDataSelector);
  const marketplaceType = yield select(marketplaceSelector);
  const isCommercial = marketplaceType === MarketplaceType.Commercial;

  if (!listingSearchData) {
    yield take(fetchListingSearchDataPattern);
    listingSearchData = yield select(listingSearchDataSelector);

    if (!listingSearchData) {
      yield put(navigateTo(isCommercial ? Route.CommercialMarketLanding : Route.Home, {}, { replace: true }));
      yield put(resetDomainData({ loadType: LoadType.ListingSearchData }));
      return;
    }
  }

  if (listingSearchData && listingSearchData.status !== ListingStatusType.Displayed) {
    const roomsRange = formatRoomsRange( isCommercial ? listingSearchData.rooms : listingSearchData.beds);
    const options = {
      term: [ listingSearchData.address.neighbourhoodDocId || listingSearchData.address.cityDocId || DEFAULT_CITY_TERM ],
      dealType: listingSearchData.dealType,
      filters: { roomsRange, sellerType: listingSearchData.sellerType },
    };

    yield put(navigateTo(isCommercial ? Route.SearchCommercial : Route.Search, options, { replace: true, isNoListingRedirect: true }));
    yield put(resetDomainData({ loadType: LoadType.ListingSearchData }));
  }
}
